export const DefaultPickUpDropOffTimeRange = ['06:00:00', '17:00:00'];
